import { useEffect, useState } from 'react';
import { jobRoleGateway } from './index';
import type { JobRoleCapabilities } from './types';

/**
 * What the signed-in person can do with job roles, as the server says it (booleans only, `GET /api/job-role-capabilities`). It decides what the screen
 * OFFERS (for example whether "Add new department" or "Set pay band" is shown); it never decides what is allowed: the server still enforces every action
 * and a 403 is still handled wherever one can arrive.
 *
 * `caps` is `null` until the answer arrives and when it cannot be read (the service is down, or an older server): the screen then offers everything and
 * relies on the server's refusal, exactly as it did before capabilities existed.
 */
export function useJobRoleCapabilities(): { caps: JobRoleCapabilities | null; loaded: boolean } {
  const [state, setState] = useState<{ caps: JobRoleCapabilities | null; loaded: boolean }>({ caps: null, loaded: false });
  useEffect(() => {
    const controller = new AbortController();
    jobRoleGateway
      .getCapabilities(controller.signal)
      .then((caps) => { if (!controller.signal.aborted) setState({ caps, loaded: true }); })
      .catch(() => { if (!controller.signal.aborted) setState({ caps: null, loaded: true }); });
    return () => controller.abort();
  }, []);
  return state;
}
